<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-1">The Point in the Market</p>
<p class="Book-Subtitle" xml:lang="en-GB">A Mamur Zapt Mystery</p>
<p class="Book-Author" xml:lang="en-GB">Michael Pearce</p>
<p class="Book-Publisher para-style-override-1" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="Body-Center"><span><img alt="29375.png" class="frame-1" src="image/29375.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Point_in_the_Market.vue?b80577aa